/**
 *
 * Asynchronously loads the component for SurveyTranslationPage
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'), {
  fallback: null,
});
